import React, { useContext } from "react";
import english from "../../language/menuElakay_en.json";

export const DropshippingLanguageContext = React.createContext(null);

// The existing Elakay language catalog remains the single translation source.
export const dropshippingText = (infoSource, namespace = "dropshippingInterne") => (key, values = {}) => {
  const catalog = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI);
  const text = catalog?.[namespace]?.[key] || english[0].frontElakayHardcodedText?.[namespace]?.[key] || key;
  return String(text).replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
};

export const useDropshippingText = (infoSource, namespace) => {
  const context = useContext(DropshippingLanguageContext);
  return dropshippingText(infoSource || context, namespace);
};
